module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/natalia-targoni-5e78c06567c242066c19db2dad51acf4.webp";